// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"223":"cceda8d5979f6d637cb5","245":"9bfe2e56f8f908089980","453":"7daed126b443b709a55c","522":"386acef608aee09f39d0"}[chunkId] + ".js";
};